import {IonCol, IonGrid, IonIcon, IonRow, IonSelect, IonSelectOption, IonSpinner} from '@ionic/react';
import { add, remove, home } from 'ionicons/icons';
import React from "react";

export const PropertyFilter = ({properties, value, onChange}) => {
  const options = properties !== null
      ? Object.values(properties).map(item => (
          <IonSelectOption key={item.id} value={item.id}>
            {item.name}
          </IonSelectOption>
      ))
      : (
          <IonSelectOption value="loading" disabled>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <IonSpinner color="teal" style={{ width: 18, height: 18 }} />
              <span>Loading list ...</span>
            </div>
          </IonSelectOption>
      );

  return (
    <IonGrid fixed>
      <IonRow class='ion-align-items-center'>
        <IonCol size='1'>
          <IonIcon icon={home} />
        </IonCol>

        <IonCol size='11'>
          <IonSelect
            label='Select Property'
            justify='space-between'
            fill='solid'
            interface='popover'
            toggleIcon={add}
            expandedIcon={remove}
            value={value}
            onIonChange={(e) => onChange(e.detail.value)}
          >
            <IonSelectOption value=''>All properties</IonSelectOption>
            {options}
          </IonSelect>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
